import { Flex, FlexProps, Grid, Image } from '@chakra-ui/react';
import { Dispatch, SetStateAction, useMemo } from 'react';
import { IContent } from '../featured';
import usePaginationController from 'src/providers/PaginationController/usePaginationController';

enum StyleType {
	ACTIVE,
	INACTIVE,
}

interface IRecommended {
	data: IContent[];
	setActive: Dispatch<SetStateAction<IContent>>;
	active: IContent;
}

export const Recommended = ({ data, setActive, active }: IRecommended) => {
	const {
		currentPage,
		advancePage,
		recedePage,
		elementsTotal: gamesTotal,
		initElementsTotal: initGamesTotal,
		elementsPerPage,
	} = usePaginationController(4);

	const style: { [type in StyleType]: Pick<FlexProps, 'p' | 'w' | 'h'> } = {
		[StyleType.ACTIVE]: {
			p: '0px',
			w: '142px',
			h: '192px',
		},
		[StyleType.INACTIVE]: {
			p: '7px',
			w: '131px',
			h: '173px',
		},
	};

	const gameNodes = useMemo(
		() =>
			data.map(datum => {
				const activeStyleType =
					active.game.address === datum.game.address ? StyleType.ACTIVE : StyleType.INACTIVE;

				return (
					<Flex
						{...style[activeStyleType]}
						bgColor="rgba(255,255,255,0.2)"
						borderRadius="3px"
						cursor="pointer"
						transition="all .1s"
						key={datum.game.address}
					>
						<Image
							src={datum.game.media.banner}
							onClick={() => setActive(datum)}
							borderRadius="3px"
						/>
					</Flex>
				);
			}),
		[data, active]
	);

	return (
		<Flex
			color="textAction"
			fontSize="16px"
			fontWeight="700"
			flexDirection="column"
			display={{ base: 'flex', hashup: 'flex' }}
			mt={{ base: '30px', hashup: '0px' }}
		>
			<Flex display={{ base: 'none', hashup: 'flex' }}>Recommended games</Flex>

			<Flex
				gridGap="10px"
				alignItems="center"
				minH="192px"
				display={{ base: 'none', hashup: 'flex' }}
			>
				{gameNodes}
			</Flex>

			<Grid
				justifyContent="start"
				display={{ base: 'grid', hashup: 'none' }}
				overflowX="scroll"
				position="relative"
				css={{
					'&::-webkit-scrollbar': {
						width: '0 !important',
					},
					overflow: '-moz-scrollbars-none',
					msOverflowStyle: 'none',
				}}
			>
				<Flex
					flexWrap={{ base: 'nowrap', xl: 'wrap' }}
					width={{ base: 'unset', xl: '100%' }}
					gridGap="10px"
					minHeight="309px"
					margin="0 auto"
					overflowX="scroll"
					css={{
						'&::-webkit-scrollbar': {
							width: '0 !important',
						},
						overflow: '-moz-scrollbars-none',
						msOverflowStyle: 'none',
					}}
				>
					{gameNodes}
				</Flex>
			</Grid>
		</Flex>
	);
};
